export default {"src":"/_next/static/media/facebook.6898e1ac.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};